import { IMAGES, CORE_VALUES } from "@/lib/content";
import { Reveal, Eyebrow } from "@/components/site/ui";

export function About() {
  return (
    <section id="about" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal className="order-2 lg:order-1">
          <div className="relative">
            <div className="overflow-hidden rounded-[2rem] border border-champagne/30 shadow-[0_20px_50px_rgba(184,122,91,0.15)]">
              <img src={IMAGES.graduation} alt="Leah Thames" className="w-full object-cover object-top aspect-[4/5]" />
            </div>
          </div>
        </Reveal>
        <div className="order-1 lg:order-2">
          <Reveal><Eyebrow>About Leah</Eyebrow></Reveal>
          <Reveal delay={0.05}><h2 className="mt-4 font-heading text-3xl md:text-5xl text-ink leading-tight">A New Generation of Athlete</h2></Reveal>
          <Reveal delay={0.1}>
            <div className="mt-6 space-y-5 font-body text-base md:text-lg text-ink/75 leading-relaxed">
              <p>Leah Thames is a professional 400m and 200m sprinter and accomplished relay athlete redefining what an elite athlete can look like: competitive, feminine, and unapologetically ambitious.</p>
              <p>As a recent college graduate and NCAA Championship qualifier, Leah is building her professional career while inviting others to experience the journey alongside her.</p>
              <p className="font-accent text-2xl md:text-3xl italic text-bronze">Because chasing big dreams should never require sacrificing who you are.</p>
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-8 flex flex-wrap gap-2">
              {CORE_VALUES.map((v) => (
                <span key={v} className="rounded-full border border-champagne/40 bg-ivory px-4 py-2 font-body text-xs uppercase tracking-wide text-ink/70">{v}</span>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 font-accent text-2xl md:text-3xl italic text-ink leading-snug border-l-2 border-bronze pl-5">
              "I believe women can be powerful and feminine, competitive and kind, ambitious and authentic."
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
